var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 40184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9998 3.82617H8.04346",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.13038 3.82617H1",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.0001 10.0286H16.6523",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.7389 10.0286H1",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.9999 16.2319H5.6958",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1.78259 16.2319H1",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.08698 6.1522C5.43742 6.1522 4.91309 5.63271 4.91309 4.98915V2.66305C4.91309 2.0195 5.43742 1.5 6.08698 1.5C6.73653 1.5 7.26087 2.0195 7.26087 2.66305V4.98915C7.26087 5.63271 6.73653 6.1522 6.08698 6.1522Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.6954 12.3551C14.0458 12.3551 13.5215 11.8356 13.5215 11.192V8.86593C13.5215 8.22238 14.0458 7.70288 14.6954 7.70288C15.3449 7.70288 15.8693 8.22238 15.8693 8.86593V11.192C15.8693 11.8356 15.3449 12.3551 14.6954 12.3551Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.73932 18.4996C3.08977 18.4996 2.56543 17.9801 2.56543 17.3366V15.0105C2.56543 14.3669 3.08977 13.8474 3.73932 13.8474C4.38887 13.8474 4.91321 14.3669 4.91321 15.0105V17.3366C4.91321 17.9801 4.38887 18.4996 3.73932 18.4996Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilter);
export default __webpack_public_path__ + "static/media/ic_filter.613f65b2031f5d3b29a5e541a0751d45.svg";
export { ForwardRef as ReactComponent };